import { render, staticRenderFns } from "./businessordersdetail.vue?vue&type=template&id=0ffe42ff&scoped=true"
import script from "./businessordersdetail.vue?vue&type=script&lang=js"
export * from "./businessordersdetail.vue?vue&type=script&lang=js"
import style0 from "./businessordersdetail.vue?vue&type=style&index=0&id=0ffe42ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffe42ff",
  null
  
)

export default component.exports